module.exports = __webpack_public_path__ + "images/ForeScout-08ecdf.png";